module.exports = __webpack_public_path__ + "535b5384d9e8683b0908a185ec847d74.png";